module.exports = __webpack_public_path__ + "static/media/404-nobg-web.9ef6c609.png";